
import { Box, Button, Stack, Typography } from "@mui/material";
import { RainbowText } from "assets/styled-components/RainbowText";
import { AI_FORM_STEPS } from "constants/steps";
import EdgeCasesChecker from "./helpers/EdgeCasesChecker";
import { useSelector } from "react-redux";

export default function FirstStep({ setIsDialogOpen, setSteps }) {
    const { id: candidateID } = useSelector((state) => state.currentCandidate);
    const hasLocalStorageAIData = Boolean(localStorage.getItem(`currentCandidateAI-${candidateID}`));

    if (!hasLocalStorageAIData) {
        return (
        <Box mt={3} px={4} mb={4}>
            <Box mb={2}>
                <Typography variant="body1" mb={1}>
                    You are about to parse candidate information{" "}
                    <RainbowText>
                        <b>using AI</b>
                    </RainbowText>
                    . This may take a few moments.{" "}
                    <b>
                        Please note that any information already provided will
                        be overwritten.
                    </b>
                </Typography>
                <EdgeCasesChecker />

            </Box>
            <Stack gap={2}>
                <Typography variant="body1" mb={4}>
                    Are you sure you want to proceed?
                </Typography>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button
                        color="gray"
                        variant="text"
                        onClick={() => {
                            setSteps(AI_FORM_STEPS.SECOND);
                        }}
                    >
                        Yes, do your magic
                    </Button>
                    <Button
                        color="gray"
                        variant="text"
                        onClick={() => {
                            setIsDialogOpen(false);
                        }}
                    >
                        Cancel
                    </Button>
                </Stack>
            </Stack>
        </Box>
        );
    };
    return (
        <Box mt={3} px={4} mb={4}>
            <Box mb={2}>
                <Typography variant="body1" mb={1}>
                    It seems there is already AI-parsed data for this candidate stored locally.
                </Typography>
            </Box>
            <Stack gap={2}>
                <Typography variant="body1" mb={4}>
                    Do you want to use the existing AI-parsed data or re-parse the candidate information?
                </Typography>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button
                        color="gray"
                        variant="text"
                        onClick={() => {
                            setSteps(AI_FORM_STEPS.SECOND);
                        }}
                    >
                        Yes, proceed with existing data
                    </Button>
                    <Button
                        color="gray"
                        variant="text"
                        onClick={() => {
                            setSteps(AI_FORM_STEPS.SECOND);
                            localStorage.removeItem(`currentCandidateAI-${candidateID}`);
                        }}
                    >
                        Re-parse candidate information
                    </Button>
                    <Button
                        color="gray"
                        variant="text"
                        onClick={() => {
                            setIsDialogOpen(false);
                        }}
                    >
                        Cancel
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
}
